const DEFAULT_TUPAS_STATE = {
    isFetching: false,
	tupasProviders: []
};

export function tupasForm(state = DEFAULT_TUPAS_STATE, action) {
    switch (action.type) {

        case 'TUPASFORM_FETCHING_TUPAS': {
            var newstate = Object.assign({}, state, {
                tupasProviders: state.tupasProviders,
                isFetching: action.isFetching
            });

            return newstate;
        }
      
        case 'TUPASFORM_ADDUPDATE_TUPAS': { 
            
            var newstate = Object.assign({}, state, 
				{
                    tupasProviders: action.data,
                    isFetching: false
                } );
            return newstate;
                            
          } 
        default:
          return state;
    }
}
